/**
 * Created by hp on 2017/6/20.
 */
import errorImg from '../images/no-source.png';

const defaults = {
    showError: false,
    img: errorImg,
    tips: '网页加载出错，请稍后再试。',
    href: '/?fr=error',
    btn: '返回',
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'ERROR_SHOW':
            return {...defaults, ...action.payload, showError: true};
        case 'ERROR_HIDE':
            return {...state, showError: false};
        case 'PAGE_INIT':
            return {...state, showError: false};
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/error.js